module.exports = __webpack_public_path__ + "static/media/background.cb51f068.jpg";